import { useCallback } from 'react';
import { compose } from 'redux';
import withStyles from '@material-ui/styles/withStyles';
import { Grid, Typography } from '@material-ui/core';
import TableRowExpandable from 'app/components/TableRowExpandable';
import EditorStateViewer from 'app/components/EditorStateViewer';
import { stringToEditorState } from 'utils/app.util';

const ActivityLogsTableRow = ({ classes, item: activity, ...rest }) => {
  const commentEditorState = activity.comment
    ? stringToEditorState(activity.comment)
    : null;

  const mitigationEditorState = activity.mitigationSolutions
    ? stringToEditorState(activity.mitigationSolutions)
    : null;
  const renderDetails = useCallback(
    (isDoRender) => {
      return isDoRender ? (
        <Grid container className={classes.subRow}>
          <Grid item xs={6} padding={2}>
            <Grid container direction="column">
              <Grid item>
                <Typography variant="caption">Comment</Typography>
              </Grid>
              <Grid item>
                {commentEditorState ? (
                  <Typography variant="caption">
                    <EditorStateViewer editorState={commentEditorState} />
                  </Typography>
                ) : (
                  '-'
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} padding={2}>
            <Grid container direction="column">
              <Grid item>
                <Typography variant="caption">
                  Solutions for Mitigating Challenges
                </Typography>
              </Grid>
              <Grid item>
                {mitigationEditorState ? (
                  <Typography variant="caption">
                    <EditorStateViewer editorState={mitigationEditorState} />
                  </Typography>
                ) : (
                  '-'
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : null;
    },
    [classes.subRow, commentEditorState, mitigationEditorState],
  );

  return <TableRowExpandable {...rest} renderDetails={renderDetails} />;
};

const styles = (theme) => ({
  subRow: {
    padding: theme.spacing(4),
  },
});

export default compose(withStyles(styles))(ActivityLogsTableRow);
